import { __assign } from "tslib";
// DS: CR36
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { formatDate, DATE_FORMATS } from '../Timestamp/functions';
import { BiEventType, BiLink } from '../biLogger';
import { default as HomeIcon } from '../Icons/Home';
import PlusIcon from '../Icons/Plus';
import shortenNumber from '../utils/shortenNumber';
import { ResourceType } from '../types/resource';
import Button from '../Button';
import { MobileContext } from '../Context';
import { IconSize } from '../Icons/IconWrap';
import s from './MiniGroupCard.scss';
export var MiniGroupCard = function (_a) {
    var _b = _a.group, user = _b.user, _c = _b.user, imageUrl = _c.usericon, username = _c.username, details = _c.details, _d = _c.stats, stats = _d === void 0 ? { watchers: 0, friends: 0 } : _d, profile = _c.profile, userId = _c.userId, description = _b.description, style = _a.style, dataHook = _a.dataHook, className = _a.className;
    var _e = useTranslation(), t = _e.t, i18n = _e.i18n;
    var isMobile = useContext(MobileContext);
    var defaultGroupAvatar = 'https://a.deviantart.net/avatars-big/default_group.gif';
    return (React.createElement("div", { className: classnames(s['root'], className), style: isMobile ? __assign(__assign({}, style), { height: undefined }) : style, "data-hook": dataHook },
        React.createElement(BiLink, { href: Url.userLink(username), title: username, biData: {
                evid: BiEventType.ITEM_CLICK,
                itemid: userId,
                typeid: ResourceType.GROUP,
            } },
            React.createElement("div", { className: s['inner'] },
                imageUrl && imageUrl !== defaultGroupAvatar ? (React.createElement("img", { className: s['group-image'], src: imageUrl, alt: username, "aria-hidden": true })) : (React.createElement("div", { className: classnames(s['group-image'], s['no-image']), "aria-hidden": true })),
                React.createElement("div", { className: s['group-name'], title: username },
                    React.createElement("span", { className: s['group-name-text'] }, username),
                    React.createElement(HomeIcon, { className: s['group-name-icon'], customSizable: true, "aria-hidden": true })),
                React.createElement("div", { className: s['group-description'], title: profile && profile.tagline }, profile && profile.tagline),
                React.createElement("div", { className: s['group-stats'] },
                    React.createElement("div", { className: s['watchers'] }, t('miniGroupCard.watchers', {
                        formattedCount: shortenNumber(stats.watchers),
                        count: stats.watchers,
                    })),
                    React.createElement("span", { className: s['stat-separator'], "aria-hidden": true }, "|"),
                    React.createElement("div", { className: s['created-date'] }, t('miniGroupCard.dateCreated', {
                        date: details
                            ? formatDate(details.joindate, DATE_FORMATS.Date.MonthYear, i18n.language)
                            : '',
                    }))),
                React.createElement(Button, { className: s['join-button'], view: "b16-undisciplined-designers", href: Url.userLink(username), "aria-hidden": true },
                    React.createElement(PlusIcon, { size: IconSize.NANO, disableDefaultColors: true, className: s['plus-icon'] }),
                    t('miniGroupCard.joinGroup'))))));
};
MiniGroupCard.displayName = 'MiniGroupCard';
export default MiniGroupCard;
//# sourceMappingURL=MiniGroupCard.js.map